// src/utils/multipartUpload.js
import axios from 'axios';

/**
 * 1️⃣ Initiate a multipart upload
 */
export async function initiateMultipartUploadConversion(baseUrl, userId, filename, fileSize, fileExtension) {
    const res = await axios.post(
        `${baseUrl}/convert/multipart_file_upload`,
        { user_id: userId, filename: filename, file_size_bytes: fileSize, file_extension: fileExtension }
    );
    console.log("Response from /convert/multipart_file_upload:", res);
    // { file_id, upload_id, presigned_urls, part_size, num_parts, filename }

    return res.data.message; // { file_id, upload_id, presigned_urls, part_size, num_parts, filename }
}

export async function uploadMultipartPartsConversion(file, presignedUrls, onPartComplete) {
    const total = presignedUrls.length;
    let done = 0;

    const uploads = presignedUrls.map(async ({ part_number, url, start_byte, end_byte }) => {
        // grab the exact bytes
        const slice = file.slice(start_byte, end_byte, 'application/octet-stream');
        const buffer = await slice.arrayBuffer();

        // fire a bare fetch, no axios
        const res = await fetch(url, {
            method: 'PUT',
            mode: 'cors',          // make sure CORS is on
            credentials: 'omit',   // we don’t need cookies/auth
            body: buffer
        });
        console.log(`Upload part ${part_number} to ${url} returned ${res}`); // 200, 403, etc

        // If it 403s, dump the XML right into console:
        if (!res.ok) {
            const text = await res.text();
            console.error(`Part ${part_number} failed with ${res.status}`, text);
            throw new Error(`Upload part ${part_number} failed: see console for AWS XML`);
        }

        // success, grab the ETag
        const etag = res.headers.get('ETag');
        console.log("ETag for part", part_number, etag); // ETag: "abc12345def67890" (example format, actual value will vary)
        if (!etag) {
            console.error(`Part ${part_number} succeeded but no ETag returned`);
            throw new Error(`No ETag on part ${part_number}`);
        }

        // bump progress
        done++;
        onPartComplete(Math.round((done / total) * 100));

        return { part_number, etag };
    });

    const results = await Promise.all(uploads);
    return results
        .sort((a, b) => a.part_number - b.part_number)
        .map(r => r.etag);
}



/**
 * 3️⃣ Complete the multipart upload on S3
 */
export async function completeMultipartUploadConversion(baseUrl, userId, fileId, etagValues) {
    const res = await axios.post(
        `${baseUrl}/convert/complete_multipart_file_upload`,
        { user_id: userId, file_id: fileId, etag_values: etagValues }
    );
    // {
    //             "message": "Multipart upload completed successfully. You can now call convert to convert the file to pdf",
    //             "file_id": file_id,
    //             "user_id": user_id,
    //             "filename": filename_secure
    //         }
    console.log("response from /convert/complete_multipart_file_upload:", res);
    return res;
}
